/* eslint-disable @typescript-eslint/naming-convention */
export enum MerchantAccountType {
  ProPay = 1,
  Payrix = 2,
}
